import { ChangeDetectionStrategy, Component, SimpleChanges, OnChanges } from "@angular/core";
import { SidebarFiltersBase } from "../../shared/shared/sidebar-filters-base";

@Component({
    selector: "bs-organizations-filters",
    templateUrl: "elements-organizations-filters.component.html",
    styleUrls: ["elements-organizations-filters.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElementsOrganizationsFiltersComponent extends SidebarFiltersBase {}
